import type { RouteObject } from 'react-router-dom'
import Layout from '@/components/Layout'
import { useRoutes } from 'react-router-dom'
import Home from '@/pages/Home'
import Budget503020 from '@/pages/calculators/Budget503020'
import NetWorth from '@/pages/calculators/NetWorth'
import EmergencyFund from '@/pages/calculators/EmergencyFund'
import MintLoan from '@/pages/calculators/MintLoan'
import CreditCardPayoff from '@/pages/calculators/CreditCardPayoff'
import MortgagePayoff from '@/pages/calculators/MortgagePayoff'
import NftMintCost from '@/pages/calculators/NftMintCost'
import SolanaMintCost from '@/pages/calculators/SolanaMintCost'
import SilverCoinValue from '@/pages/calculators/SilverCoinValue'
import GoldEagleMint from '@/pages/calculators/GoldEagleMint'
import About from '@/pages/About'
import Disclaimer from '@/pages/Disclaimer'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import TermsOfService from '@/pages/TermsOfService'
import Contact from '@/pages/Contact'
import NotFound from '@/pages/NotFound'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/calculators/budget-50-30-20', element: <Budget503020 /> },
  { path: '/calculators/net-worth', element: <NetWorth /> },
  { path: '/calculators/emergency-fund', element: <EmergencyFund /> },
  { path: '/calculators/mint-loan', element: <MintLoan /> },
  { path: '/calculators/credit-card-payoff', element: <CreditCardPayoff /> },
  { path: '/calculators/mortgage-payoff', element: <MortgagePayoff /> },
  { path: '/calculators/nft-mint-cost', element: <NftMintCost /> },
  { path: '/calculators/solana-mint-cost', element: <SolanaMintCost /> },
  { path: '/calculators/silver-coin-value', element: <SilverCoinValue /> },
  { path: '/calculators/gold-eagle-mint', element: <GoldEagleMint /> },
  { path: '/about', element: <About /> },
  { path: '/disclaimer', element: <Disclaimer /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/terms-of-service', element: <TermsOfService /> },
  { path: '/contact', element: <Contact /> },
  { path: '*', element: <NotFound /> },
]

function App() {
  const element = useRoutes(routes)
  return <Layout>{element}</Layout>
}

export default App
